
import React from 'react';
import { RegionsData } from './types';

interface RegionBreakdownProps {
  deviceCounts: Record<string, Record<string, number>>;
  regions: RegionsData;
}

const RegionBreakdown: React.FC<RegionBreakdownProps> = ({ deviceCounts, regions }) => {
  // This component now returns an empty fragment to remove the region breakdown
  return <></>;
};

export default RegionBreakdown;
